import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult } from '@azure/msal-browser';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { CommonService } from 'src/app/services/common/common.service';
import { SessionStorageService } from 'src/app/services/storage/session-storage.service';
import { Storage_Keys } from 'src/app/services/storage/storage.keys';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  password: boolean;
  loginForm: FormGroup;
  submitted = false;
  errorMsg = '';
  sendmsg: string;
  data: any;
  roles: any = ['admin', 'product_and_pricing_approver', 'product_and_pricing_creator', 'read_only'];
  admin: boolean = false;
  product_and_pricing_approver: boolean = false;
  product_and_pricing_creator: boolean = false;
  read_only: boolean = false;

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private storage: StorageService,
    private commonService: CommonService,
    private msalService: MsalService,
    private sessionStorage: SessionStorageService,
  ) {
    this.loginForm = new FormGroup({
      "email": new FormControl('', Validators.required),
      "password": new FormControl('', Validators.required),
    })
  }

  ngOnInit(): void {
  }

  showPassword() {
    this.password = !this.password;
  }

  get a() {
    return this.loginForm.controls;
  }

  userLogin() {
    this.submitted = true;
    if (this.loginForm.invalid) {
      return
    }
    let payload = {
      "email": this.loginForm.value.email.toLowerCase(),
      "password": this.loginForm.value.password
    }
    // return
    this.commonService.presentSpinner();
    this.authenticationService.login(payload).then(
      (res) => {
        if (res.code == 200) {
          this.commonService.showSuccessToastMsg(res.message);
          this.storage.set(Storage_Keys.AdminData, res.adminData);
          this.storage.set(Storage_Keys.authtoken, res.adminData.authToken);
          this.storage.set(Storage_Keys.loginVia, 'normal');
          this.setRoles(this.roles, res.adminData.role);
          this.storage.set(Storage_Keys.roles, { admin: this.admin || false, approver: this.product_and_pricing_approver || false, creator: this.product_and_pricing_creator || false, readOnly: this.read_only || false });
          this.sessionStorage.set(Storage_Keys.roles, { admin: this.admin || false, approver: this.product_and_pricing_approver || false, creator: this.product_and_pricing_creator || false, readOnly: this.read_only || false });
          this.router.navigate(['/admin/gbb/versions']);
          this.sendmsg = "Hello"
        } else {
          this.commonService.showErrorToastMsg(res.error.message || res.error.error.message);
        }
      }
    ).finally(
      () => {
        this.commonService.dismissSpinner();
      }
    );
  }

  microsoftSignIn() {
    this.msalService.loginPopup().subscribe((respoonse: AuthenticationResult) => {
      this.msalService.instance.setActiveAccount(respoonse.account);
      this.storage.set(Storage_Keys.AdminData, respoonse);
      this.storage.set(Storage_Keys.authtoken, respoonse.accessToken);
      let payload = {
        "email": respoonse.account.username,
      }
      this.commonService.presentSpinner();
      this.authenticationService.ssoLogin(payload).then(
        (res) => {
          if (res.code == 200) {
            this.data = res.data[0]
            this.storage.set(Storage_Keys.AdminData, res.data[0]);
            this.storage.set(Storage_Keys.authtoken, res.data[0].authToken);
            this.storage.set(Storage_Keys.loginVia, 'sso');
            this.setRoles(this.roles, res.data[0].role);
            this.storage.set(Storage_Keys.roles, { admin: this.admin || false, approver: this.product_and_pricing_approver || false, creator: this.product_and_pricing_creator || false, readOnly: this.read_only || false });
            this.sessionStorage.set(Storage_Keys.roles, { admin: this.admin || false, approver: this.product_and_pricing_approver || false, creator: this.product_and_pricing_creator || false, readOnly: this.read_only || false });
            this.router.navigate(['/admin/gbb/versions']);
            this.sendmsg = "Hello"
          } else {
            this.commonService.showErrorToastMsg(res.error.message || res.error.error.message);
          }
        }
      ).catch(
        (error) => {

        }
      ).finally(
        () => {
          this.commonService.dismissSpinner();
        }
      );
    }
    )

  }

  setRoles(roles: any, loginRoles: any) {
    loginRoles.map((item: any) => {
      if (roles.includes(item)) {
        eval('this.' + item + ' = true;');
      }
    })
  }

}
